module.exports = __webpack_public_path__ + "static/media/weathered-oak-driftwood.be7e3921.png";